import clsx from 'clsx';
import React from 'react';

import IconDeepResearch from '@components/Images/DeepResearch/IconDeepResearch';

import './styles.scss';

const SparkleSpinner = ({ className }: { className?: string }) => (
  <div
    className={clsx('sparkle-spinner relative mx-auto w-40', className)}
    data-testid="sparkle-spinner"
  >
    <IconDeepResearch className="text-pro-gold" width={32} height={32} />
    <IconDeepResearch className="absolute -right-2 -top-10 text-pro-gold" width={20} height={20} />
  </div>
);

export default SparkleSpinner;
